var React = require('react');

function Send (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.8 60c-.3 0-.7 0-1-.1-1.2-.2-2.3-.8-3.2-1.6-.9-.9-1.4-2-1.6-3.2s.1-2.4.7-3.5L14.4 30 .8 8.5v-.1c-.7-1-.9-2.3-.8-3.5.2-1.2.7-2.3 1.6-3.2S3.6.3 4.8.1 7.2 0 8.3.6l53.4 26.2c.6.3 1.1.8 1.5 1.3.4.6.6 1.2.6 1.9s-.2 1.3-.5 1.9c-.4.6-.9 1-1.5 1.3L8.4 59.4c-.9.4-1.7.6-2.6.6zM3.5 6.8l14.2 22.3a1.72 1.72 0 0 1 0 1.7L3.4 53.2c-.2.4-.3.9-.3 1.4.1.5.3 1 .7 1.4s.9.7 1.5.7c.6.1 1.1 0 1.7-.2l53.4-26.2.3-.4.4-1.8-.7 1.4L7 3.4a3.21 3.21 0 0 0-1.7-.2c-.5.1-1.1.4-1.4.8-.4.3-.7.8-.7 1.3-.1.6 0 1.1.3 1.5z","key":0}),React.createElement("path",{"d":"M62.2,31.6H16.3c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6h45.9c0.9,0,1.6,0.7,1.6,1.6S63.1,31.6,62.2,31.6z","key":1})]);
}

Send.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 63.8 60","overflow":"visible"};

module.exports = Send;

Send.default = Send;
